export default "__VITE_ASSET__7a305fcc__"